import { PlantMark } from "@/app/components/PlantMark";
import { PlantedAgo } from "@/app/components/PlantedAgo";
import type { Plant } from "@/types";

type PlantRowVariant = "inline" | "card";

interface PlantRowProps {
  plant: Plant;
  onClick: () => void;
  variant?: PlantRowVariant;
}

const CONTAINER: Record<PlantRowVariant, string> = {
  inline: "w-full border-0 bg-transparent px-1.5 py-2 rounded-xl flex items-center gap-3 cursor-pointer text-left transition-[background] duration-120 hover:bg-cream-2",
  card: "w-full flex items-center gap-3 bg-paper border border-line rounded-2xl px-3 py-2.5 cursor-pointer text-left transition-all duration-150 hover:border-moss-2",
};

export function PlantRow({ plant, onClick, variant = "inline" }: PlantRowProps) {
  const subtitle = plant.species?.scientific ?? plant.species?.common ?? "";

  return (
    <button onClick={onClick} className={CONTAINER[variant]}>
      <PlantMark plant={plant} size={42} />
      <div className="flex-1 min-w-0">
        <h4 className="m-0 font-sans text-[14.5px] font-medium text-ink">
          {plant.nickname}
          <PlantedAgo plantedOn={plant.plantedOn} />
        </h4>
        {subtitle && (
          <p className="mt-px mx-0 mb-0 text-xs italic font-display text-ink-3">{subtitle}</p>
        )}
      </div>
    </button>
  );
}
